import wretch from "wretch";
import QueryStringAddon from "wretch/addons/queryString";

export const wretchWithAddons = wretch().addon(QueryStringAddon);
